import React, { useEffect } from 'react';
import { Grid, Typography, Link, Box, IconButton } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router';
import { Facebook, Instagram, Language } from '@mui/icons-material';
import './styles.scss';
import {
  Layout,
  Loading,
  UserNavbar,
  TranslucentContainer,
  ReturnButton,
} from '../../../components';
import * as VenuesActions from '../../../core/venues/action';
import Banner from '../venues/components/Banner/Banner';
import { useStorageImage } from '../../../hooks';

export default function VenueProfile() {
  const { loading, venueDetails } = useSelector((store) => store.venues);
  const { venueId } = useParams();
  const dispatch = useDispatch();

  const banner = useStorageImage(venueDetails?.banner);
  useEffect(() => {
    dispatch(VenuesActions.getVenueById(venueId));
  }, []);

  const validateUrl = (url) => {
    const regex = /^(https?|http):\/\//i;
    return regex.test(url);
  };
  return (
    <Layout>
      <UserNavbar />
      {loading ? (
        <Loading />
      ) : (
        <Grid container justifyContent="center" textAlign="center" pt={10}>
          <Grid
            item
            xs={12}
            md={12}
            marginLeft={{ md: 18 }}
            justifyContent="left"
            sx={{ display: 'flex' }}>
            <ReturnButton />
          </Grid>
          <TranslucentContainer>
            <Grid container spacing={2} marginTop={2}>
              <Grid item xs={12} textAlign="left">
                <Banner picture={banner} />
                <Typography component="div" variant="h5" textAlign="left" marginBottom="1rem">
                  {venueDetails?.name ? venueDetails?.name : 'Company name not provided'}!
                </Typography>
                <Grid item xs={12} display="flex" flexDirection="row" gap="1rem" mb="1rem">
                  {venueDetails?.social_network?.length > 0 ? (
                    <>
                      {venueDetails?.social_network.find((item) => item.name === 'Facebook') !=
                      null ? (
                        <Link
                          href={
                            venueDetails.social_network.find((item) => item.name === 'Facebook')
                              ?.url
                          }
                          className="Link"
                          target="_blank"
                          title="Open Facebook site">
                          <Facebook sx={{ color: '#FD9D7E' }} />
                        </Link>
                      ) : null}
                      {venueDetails?.social_network.find((item) => item.name === 'Instagram') !=
                      null ? (
                        <Link
                          href={
                            venueDetails.social_network.find((item) => item.name === 'Instagram')
                              ?.url
                          }
                          className="Link"
                          target="_blank"
                          title="Open Instagram site">
                          <Instagram sx={{ color: '#FD9D7E' }} />
                        </Link>
                      ) : null}
                    </>
                  ) : null}
                  {venueDetails?.website && (
                    <Link
                      href={
                        validateUrl(venueDetails?.website)
                          ? venueDetails?.website
                          : `https://${venueDetails?.website}`
                      }
                      className="Link"
                      target="_blank"
                      title="Open Website">
                      <Language sx={{ color: '#FD9D7E' }} />
                    </Link>
                  )}
                </Grid>
                <Typography variant="subtitle1">Venue description</Typography>
                <Typography variant="body2" marginBottom="0.5rem" textAlign="justify">
                  {venueDetails?.description
                    ? venueDetails?.description
                    : 'Description not provided'}
                </Typography>
                <Typography variant="subtitle1">Address</Typography>
                <Typography variant="body1" marginBottom="0.5rem" textAlign="justify">
                  {venueDetails?.business_address
                    ? venueDetails?.business_address
                    : 'Address not provided'}
                </Typography>
                <Typography variant="subtitle1">Contact Name</Typography>
                <Typography variant="body2" marginBottom="0.5rem" textAlign="justify">
                  {venueDetails?.contact_name ? venueDetails.contact_name : 'Contact not provided'}
                </Typography>
                <Typography variant="subtitle1">Business type</Typography>
                <Grid xs={12} sx={{ display: 'flex', mt: 1 }}>
                  <Box
                    key={venueDetails?.business_type}
                    sx={{
                      borderRadius: '17px',
                      backgroundColor: '#0997BA',
                      py: 1,
                      px: 2,
                      color: 'white',
                      justifyContent: 'center',
                      mr: 1,
                    }}>
                    {venueDetails?.business_type
                      ? venueDetails.business_type
                      : 'Business type not provided'}
                  </Box>
                </Grid>
              </Grid>
            </Grid>
          </TranslucentContainer>
        </Grid>
      )}
    </Layout>
  );
}
